import { render, staticRenderFns } from "./PageTenderDetails.vue?vue&type=template&id=91c92f20"
import script from "./PageTenderDetails.vue?vue&type=script&lang=js"
export * from "./PageTenderDetails.vue?vue&type=script&lang=js"
import style0 from "./PageTenderDetails.vue?vue&type=style&index=0&id=91c92f20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports